<div class="card border-0 shadow-sm mb-4 rounded-4" [hidden]="hideMain">
	<div class="card-body p-4">
		<!-- Header / Subject -->
		<div class="mb-4 pb-3 border-bottom">
			<h3 class="fw-bold mb-1 text-dark">{{mail?.subject || '(No Subject)'}}</h3>
		</div>

		<!-- Sender & Meta Info -->
		<div class="d-flex flex-column flex-md-row align-items-md-start mb-4 bg-light rounded-4 py-4 px-3 border">
			<div class="me-3 mb-2 mb-md-0 text-primary opacity-75 mt-1 d-none d-md-block">
				<fa-icon [icon]="['fas', 'user-circle']" size="3x"></fa-icon>
			</div>
			<div class="flex-grow-1 min-w-0">
				<div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-2">
					<div class="fs-5 fw-semibold text-dark text-truncate me-md-3">
						<fa-icon [icon]="['fas', 'user-circle']"
							class="d-md-none me-2 text-primary opacity-75"></fa-icon>
						@if(mail?.from_name){
						<a (click)="openCopyModalTrailMail()" class="text-decoration-none text-dark"
							style="cursor: pointer; transition: color 0.2s;" onmouseover="this.style.color='#0d6efd'"
							onmouseout="this.style.color='#212529'" matTooltip="{{mail?.from_email}}">
							{{mail?.from_name}}
						</a>
						}@else {
						<a (click)="openCopyModalTrailMail()" class="text-decoration-none text-dark"
							style="cursor: pointer; transition: color 0.2s;" onmouseover="this.style.color='#0d6efd'"
							onmouseout="this.style.color='#212529'" matTooltip="{{mail?.from_email}}">
							{{mail?.from_email}}
						</a>
						}
					</div>
					<div class="text-muted small fw-medium text-nowrap mt-1 mt-md-0">
						{{mail?.messageDate}}
					</div>
				</div>
				<div class="d-flex flex-wrap gap-2 align-items-center">
					<span class="text-muted small fw-semibold">To:</span>
					@for (data of mail?.toMailArr; track $index) {
					<span
						class="badge bg-white text-secondary border border-secondary border-opacity-25 rounded-pill px-3 py-1 fw-normal shadow-sm">
						{{data}}
					</span>
					}
				</div>
				@if(mail?.ccArr?.length){
				<div class="d-flex flex-wrap gap-2 align-items-center mt-2">
					<span class="text-muted small fw-semibold">CC:</span>
					@for (data of mail?.ccArr; track $index) {
					<span
						class="badge bg-white text-secondary border border-secondary border-opacity-25 rounded-pill px-3 py-1 fw-normal shadow-sm">
						{{data}}
					</span>
					}
				</div>
				}
			</div>
		</div>

		<!-- Attachments -->
		@if (mail?.email_status != 'draft' && mail?.attachmentsArr!=null && mail?.attachmentsArr.length) {
		<div class="mb-4 rounded-4 overflow-hidden shadow-sm border border-light-subtle">
			<div class="d-flex align-items-center px-4 py-3"
				style="background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%); border-bottom: 2px solid #e2e8f0;">
				<div class="rounded-3 d-flex align-items-center justify-content-center me-3"
					style="width: 40px; height: 40px; background: linear-gradient(135deg, #334155 0%, #1e293b 100%);">
					<fa-icon [icon]="['fas', 'paperclip']" class="text-white"></fa-icon>
				</div>
				<div>
					<h6 class="m-0 fw-bold text-dark">Attachments</h6>
					<span class="text-muted" style="font-size: 0.75rem;">{{mail.attachmentsArr.length}}
						{{mail.attachmentsArr.length > 1 ? 'files' : 'file'}} attached</span>
				</div>
			</div>
			<div class="p-3 bg-white">
				<view-attachments [attachmentsArr]="mail?.attachmentsArr" [allowBillingLink]="allowBillingLink"
					[mailId]="mail?.id" [apptId]="apptId">
				</view-attachments>
			</div>
		</div>
		}

		<!-- Email Body (Iframe) -->
		<div class="email-body-container bg-white rounded-3 border p-1" style="min-height: 300px;">
			@if(fetchingHtml){
			<div class="d-flex justify-content-center align-items-center h-100 py-5">
				<img src="../../../assets/img/loading.gif" class="w-100px opacity-50 my-5" />
			</div>
			}
			<iframe #iframe class="w-100 border-0" frameborder="0" scrolling="yes" (load)="resizeIframe(iframe)"
				[ngStyle]="style">
			</iframe>
		</div>
	</div>
</div>

<!-- Mail History / Trail -->
@if (mail.reply_details && showTrail) {
<div class="position-relative mt-4 mb-3 ps-3 ms-2 border-start border-3 border-secondary border-opacity-25">
	@if(isFirst){
	<div class="d-flex align-items-center mb-3 text-secondary">
		<div class="bg-light rounded-circle d-flex align-items-center justify-content-center me-2 border shadow-sm"
			style="width: 32px; height: 32px;">
			<fa-icon [icon]="['fas', 'history']"></fa-icon>
		</div>
		<h6 class="my-0 fw-bold text-uppercase" style="letter-spacing: 1px;">Mail History</h6>
	</div>
	}
	<app-mail-display [mail]="mail.reply_details" [showTrail]="true" [showReplyBtn]="false" [isFirst]="false">
	</app-mail-display>
</div>
}